import { joinChannel } from './ws-actions';
import { normalizePost } from '../services/post-utils';
import { getCategoryIds } from '../selectors/categories-selectors';

export const emitBlogOpened = () => joinChannel('blog');

export const POST_PUBLISHED = 'post/PUBLISHED';
export const UPDATE_POST_COUNTERS = 'post/UPDATE_POST_COUNTERS';

export const updatePostCounters = payload => (dispatch, getState) =>
  dispatch({
    type: UPDATE_POST_COUNTERS,
    payload: normalizePost({ post: payload, blogCategoryIds: getCategoryIds(getState()) }),
  });
